module.exports = __webpack_public_path__ + "assets/d2accd715293755cc6413d76d40a6a60.png";